import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import 'remodal';
import 'Modernizr';

import select from '../blocks/select/select';
import slider from '../blocks/slider/slider';
import fancyboxes from '../blocks/fancybox/fancybox';
import mapInit from '../blocks/map/map';
import navigation from '../blocks/navigations/navigations';

$(() => {
  svg4everybody();
  select($);
  slider($);
  fancyboxes($);
  mapInit();
  navigation($);
});



// WEBPACK FOOTER //
// ./app/scripts/app.js